import { useMemo } from 'react'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@cocoonspace/ui/components/alert-dialog'
import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { Trash2Icon } from 'lucide-react'

import { useConnectIntegration } from '~/domains/scheduling/event-types/edition/calendar-sync/use-connect-integration.hook'

export const RemoveIntegrationDialog = ({
	provider,
}: {
	provider: 'google' | 'outlook'
}) => {
	const { t } = useLingui()

	const { removeIntegration, isPending } = useConnectIntegration({
		provider,
	})

	const providerName = useMemo(() => {
		switch (provider) {
			case 'google':
				return 'Google Calendar'
			case 'outlook':
				return 'Microsoft Outlook'
		}
	}, [provider])

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button
					title={t`Désinstaller`}
					variant='ghost'
					size='sm'
					disabled={isPending}
					icon
				>
					<Trash2Icon />
				</Button>
			</AlertDialogTrigger>

			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t`Désinstaller l'intégration ${providerName} ?`}
					</AlertDialogTitle>
				</AlertDialogHeader>

				<AlertDialogDescription>
					{t`Souhaitez-vous vraiment désinstaller l'intégration ${providerName} ?`}
				</AlertDialogDescription>

				<AlertDialogFooter>
					<AlertDialogCancel>{t`Annuler`}</AlertDialogCancel>

					<AlertDialogAction onClick={removeIntegration}>
						{t`Désinstaller`}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
